import { Typography } from '@components/atoms/Typography';
import ProductItem from '@components/molecules/ProductItem';

import { TProductsListProps } from './types';

export const ProductsList = ({ items, orderCurrency }: TProductsListProps) => {
  return (
    <div className="mt-2 mb-6 space-y-2">
      <Typography textKey="Checkout.items" className="text-[14px] text-[#64748B] uppercase" />
      {items.map((item) => (
        <ProductItem key={item.id || item.name} item={item} currency={orderCurrency} />
      ))}
    </div>
  );
};
